// MuteButton.jsx
import { useCallback } from 'react';
import PropTypes from 'prop-types';

import trackMixpanel, {
  getViewId,
  ButtonId,
  EventTypes,
} from '../resource/mixpanel.js';

import AudioOnIcon from '../../img/ic_audio_on.svg';
import AudioOffIcon from '../../img/ic_audio_off.svg';

export const MuteButton = ({ id, isMuted, setMute, children }) => {
  const handleOnClick = useCallback(() => {
    trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({ pathname: window.location.pathname }),
        buttonId: isMuted
          ? ButtonId.All.ButtonMuted
          : ButtonId.All.ButtonVolume,
        messageId: id,
        extraProps: {
          isMuted: !isMuted,
        },
      },
    });
    setMute(!isMuted);
  }, [id, isMuted, setMute]);

  return children({
    isMuted,
    handleOnClick,
    iconSource: isMuted ? AudioOffIcon : AudioOnIcon,
  });
};

MuteButton.propTypes = {
  id: PropTypes.string,
  isMuted: PropTypes.bool,
  showLargeIcon: PropTypes.bool,
  setMute: PropTypes.func,
  children: PropTypes.func,
};

MuteButton.defaultProps = {
  id: '',
  isMuted: false,
  showLargeIcon: false,
  setMute: () => null,
  children: () => null,
};

export default MuteButton;
